<template>
    <div v-wechat-title="title" class="schedule-surgery">
        <crud-facecade
            ref="surgery-list"
            :key="1"
            :tableStyle="tableStyle"
            :tableHeight="tableHeight"
            :url="url"
            v-if="this.active_room_id > 0"
            :columns="columnList3"
            :buttons="buttons"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :sort="true"
            :default-sort="{ prop: 'scheduled_sequence' }"
            @exchange-row="dragSort"
            :rowDropDisabled="false"
            :columnConfig="true"
            :showSequence="false"
            @cancelSchedule="cancelSchedule"
            :selection="true"
            @loadSurgeryEditView="loadSurgeryEditView"
            @selectionChange="checkedRow"
            @printOne="printOne"
            :filterSpan="[15, 5, 6]"
        >
            <slot slot="filter">
                <el-col :md="5" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date" style="width: 160px"></item-input>
                </el-col>
                <el-col :span="8" class="align-left">
                    <el-button :type="isLoadToSchedule ? 'primary' : 'plain'" size="mini" @click="LoadUnScheduled()">
                        <span style="float: right; padding-right: 5px">待排程({{ unScheduledLength }})</span></el-button
                    >
                    <el-button :type="isLoadScheduled ? 'primary' : 'plain'" size="mini" @click="LoadAllScheduled()" title="已排程">
                        <span style="float: right; padding-right: 5px">已排程({{ ScheduledLength }})</span>
                    </el-button>
                    <el-checkbox v-model="dataArea">全部</el-checkbox>
                </el-col>
                <el-col :md="5" :xl="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="2" :xl="2">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
            </slot>

            <template slot="filter-after">
                <el-button type="primary" v-if="this.surgeryinfopush == `true`" size="mini" @click="pushSchedule()" title="手术排程回传">排程回传<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-show="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="section" v-show="ishavehelpSection(`helpSection`)">按科室分配</el-dropdown-item>
                        <el-dropdown-item command="worker" v-show="ishavehelpSection(`helpWorker`)">按术者分配</el-dropdown-item>
                        <el-dropdown-item command="surgery" v-show="ishavehelpSection(`helpSurgery`)">按术式分配</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-show="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                        <el-dropdown-item command="setAnesDoctor" v-show="ishavehelpSection(`helpSetAnesDoctor`)">设置麻醉医生</el-dropdown-item>
                        <el-dropdown-item command="clearWorkers" v-show="ishavehelpSection(`clearWorkersSettings`)">清除人员安排</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                        <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <div slot="table-title">
                <el-row>
                    <!-- <el-col :md="2" :xl="1" class="height60 padding5 padding-none-v">
                        <el-button :type="active_room_id == 0 ? 'primary' : 'button'" class="height50 width-p100 padding0" @click="active_room_id = 0">待排程<br />({{ unScheduledLength }})</el-button>
                    </el-col> -->
                    <el-col :md="22" :xl="23" class="align-left height60">
                        <ScrollPane class="height-p100">
                            <draggable
                                class="height-p100 padding-right20"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div
                                    class="height50 inline-block margin2 margin-none-v cursor-pointer room"
                                    style="min-width: 80px"
                                    :class="{ 'is-close': !room.is_open, 'is-operating': room.is_operating }"
                                    v-for="room in operationRoom"
                                    :key="room.id"
                                >
                                    <div @click="LoadActiveRoomData(room)" class="height50">
                                        <el-row class="height-p100">
                                            <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                            <el-col
                                                :span="22"
                                                class="content padding5 padding-none-v"
                                                :class="{ active: active_room_id == room.id }"
                                                :style="styleObject(active_room_id == room.id, room.room_setting)"
                                            >
                                                <el-row class="font-size10" @click="active_room_id = room.id" style="height: 22px">
                                                    <el-col :span="10" class="line-height20">
                                                        <span class="el-icon-sort" v-if="active_room_id == room.id"></span> {{ room.done }}/{{ room.total }}
                                                    </el-col>
                                                    <el-col :span="14" class="line-height20 align-right">
                                                        <span style="font-size: 11px">
                                                            <i
                                                                class="el-icon-message-solid"
                                                                title="当前手术间未具备手术资格"
                                                                @click.stop="loadCheckList(room)"
                                                                v-if="room.room_setting && room.room_setting.check_result == '不合格'"
                                                            ></i>
                                                        </span>
                                                        <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                            <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                        </span>
                                                    </el-col>
                                                </el-row>
                                                <draggable
                                                    v-bind="roomDragOption(room.is_open)"
                                                    tag="div"
                                                    class="align-center"
                                                    style="line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex"
                                                    @add="ScheduleSurgeries($event, room)"
                                                >
                                                    <span>{{ room.name }}</span>
                                                </draggable>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </draggable>
                        </ScrollPane>
                    </el-col>
                </el-row>
            </div>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis">
                            <b>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div>
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                    borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2',
                                    borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white; font-weight: bold" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag
                                :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >日间</el-tag
                            >
                            <el-tag
                                :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >内镜</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.infectious && row.infectious != '无' && row.infectious != 'NONE' && row.infectious != '未查' && row.infectious != 'NoCheck' ? 'red' : '#DFE2E7',
                                    borderColor: row.infectious ? '#f2b04b' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >传染病</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.is_local_anes && row.is_local_anes == true ? '#5AA7B0' : '#DFE2E7',
                                    borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >局麻
                            </el-tag>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }">
                <el-tooltip class="item" effect="light" placement="top">
                    <div style="min-width: 200px" slot="content">{{ row.surgeries_allInfo }}</div>
                    <div style="min-width: 100px; white-space: normal">
                        <b class="ellipsis">{{ row.anaes_methods }}</b>
                        <div class="fg-info ellipsis">{{ row.relation_text }}</div>
                    </div>
                </el-tooltip>
            </template>
            <template slot="dic_section" slot-scope="{ row }"
                ><div style="min-width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div></template
            >
            <template slot="surgeon" slot-scope="{ row }">
                <div style="min-width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
                <el-popover ref="popover" trigger="hover" @show="showPhoto(row)"><img style="width: 200px; height: 200px" :src="row.worker_photo" /> </el-popover>
                <img class="workerImg" v-if="isShowWorkerPhoto && row.surgeon_id && row.surgeon_photo" v-popover:popover :src="workerIcon" />
            </template>
            <template slot="remark" slot-scope="{ row }">
                <div style="white-space: normal">
                    <div class="fg-info">{{ row.his_remark }}</div>
                    <b>{{ row.remark }}</b>
                </div>
            </template>
        </crud-facecade>
        <crud-facecade
            ref="surgery-list"
            :key="2"
            :tableStyle="tableStyle"
            :tableHeight="tableHeight"
            v-else
            :url="url2"
            :columns="columnList2"
            :buttons="buttons"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :rowDropDisabled="false"
            :columnConfig="true"
            :showSequence="false"
            :selection="true"
            @loadSurgeryEditView="loadSurgeryEditView"
            @selectionChange="checkedRow"
            :filterSpan="[15, 5, 6]"
        >
            <slot slot="filter">
                <el-col :md="5" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="scheduling_date" style="width: 160px"></item-input>
                </el-col>
                <el-col :span="8" class="align-left">
                    <el-button :type="isLoadToSchedule ? 'primary' : 'plain'" size="mini" @click="LoadUnScheduled()">
                        <span style="float: right; padding-right: 5px">待排程({{ unScheduledLength }})</span></el-button
                    >
                    <el-button :type="isLoadScheduled ? 'primary' : 'plain'" size="mini" @click="LoadAllScheduled()" title="已排程">
                        <span style="float: right; padding-right: 5px">已排程({{ ScheduledLength }})</span>
                    </el-button>
                    <el-checkbox v-model="dataArea">全部</el-checkbox>
                </el-col>
                <el-col :md="5" :xl="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="2" :xl="2">
                    <item-input type="select" v-model="selectsurgeryType" :options="surgeryTypes" placeholder="类型" @input="changed"></item-input>
                </el-col>
            </slot>

            <template slot="filter-after">
                <el-button type="primary" v-if="this.surgeryinfopush == `true`" size="mini" @click="pushSchedule()" title="手术排程回传">排程回传<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-if="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="section" v-if="ishavehelpSection(`helpSection`)">按科室分配</el-dropdown-item>
                        <el-dropdown-item command="worker" v-if="ishavehelpSection(`helpWorker`)">按术者分配</el-dropdown-item>
                        <el-dropdown-item command="surgery" v-if="ishavehelpSection(`helpSurgery`)">按术式分配</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-if="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                        <el-dropdown-item command="setAnesDoctor" v-if="ishavehelpSection(`helpSetAnesDoctor`)">设置麻醉医生</el-dropdown-item>
                        <el-dropdown-item command="clearWorkers" v-show="ishavehelpSection(`clearWorkersSettings`)">清除人员安排</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                        <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <div slot="table-title">
                <el-row>
                    <!-- <el-col :md="2" :xl="1" class="height60 padding5 padding-none-v">
                        <el-button :type="active_room_id == 0 ? 'primary' : 'button'" class="height50 width-p100 padding0" @click="active_room_id = 0">待排程<br />({{ unScheduledLength }})</el-button>
                    </el-col> -->
                    <el-col :md="22" :xl="23" class="align-left height60">
                        <ScrollPane class="height-p100">
                            <draggable
                                class="height-p100 padding-right20"
                                v-model="operationRoom"
                                v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150, handle: '.el-icon-sort' }"
                                @change="exchangeRoom"
                            >
                                <div
                                    class="height50 inline-block margin2 margin-none-v cursor-pointer room"
                                    style="min-width: 80px"
                                    :class="{ 'is-close': !room.is_open, 'is-operating': room.is_operating }"
                                    v-for="room in operationRoom"
                                    :key="room.id"
                                >
                                    <div @click="LoadActiveRoomData(room)" class="height50">
                                        <el-row class="height-p100">
                                            <el-col :span="2" class="height-p100 title"> &nbsp; </el-col>
                                            <el-col
                                                :span="22"
                                                class="content padding5 padding-none-v"
                                                :class="{ active: active_room_id == room.id }"
                                                :style="styleObject(active_room_id == room.id, room.room_setting)"
                                            >
                                                <el-row class="font-size10" @click="active_room_id = room.id" style="height: 22px">
                                                    <el-col :span="10" class="line-height20">
                                                        <span class="el-icon-sort" v-if="active_room_id == room.id"></span> {{ room.done }}/{{ room.total }}
                                                    </el-col>
                                                    <el-col :span="14" class="line-height20 align-right">
                                                        <span style="font-size: 11px">
                                                            <i
                                                                class="el-icon-message-solid"
                                                                title="当前手术间未具备手术资格"
                                                                @click.stop="loadCheckList(room)"
                                                                v-if="room.room_setting && room.room_setting.check_result == '不合格'"
                                                            ></i>
                                                        </span>
                                                        <span style="font-size: 11px" @click.stop="loadSettingForm(room)" :class="{ hasSetting: room.room_setting }">
                                                            <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                                        </span>
                                                    </el-col>
                                                </el-row>
                                                <draggable
                                                    v-bind="roomDragOption(room.is_open)"
                                                    tag="div"
                                                    class="align-center"
                                                    style="line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex"
                                                    @add="ScheduleSurgeries($event, room)"
                                                >
                                                    <span>{{ room.name }}</span>
                                                </draggable>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </draggable>
                        </ScrollPane>
                    </el-col>
                </el-row>
            </div>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            :title="row.surgery_status"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left" :title="titleLabel(row)">
                        <div class="ellipsis">
                            <b>
                                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)` }}
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                        <div>
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                    borderColor: row.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.surgery_type }}</el-tag
                            >
                            <!-- <el-tag style="color: #f56c6c; border-color: #f56c6c; background-color: white" size="mini" v-if="row.enum_surgery_type">{{ row.surgery_type }}</el-tag> -->
                            <el-tag
                                :style="{
                                    color: row.enum_surgery_status >= 40 ? '#DFE2E7' : '#52b8d2',
                                    borderColor: row.enum_surgery_status == 40 ? '#DFE2E7' : '#52b8d2',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >{{ row.enum_surgery_status > 10 ? '已排' : '待排' }}</el-tag
                            >
                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white; font-weight: bold" size="mini">{{
                                row.enum_visit_type == 1 ? '住院' : row.enum_visit_type == 2 ? '门诊' : '体检'
                            }}</el-tag>
                            <el-tag
                                :style="{ color: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', borderColor: row.is_day_surgery ? '#6CBE5E' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >日间</el-tag
                            >
                            <el-tag
                                :style="{ color: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', borderColor: row.is_endoscopy ? '#f2b04b' : '#DFE2E7', backgroundColor: 'white', fontWeight: 'bold' }"
                                size="mini"
                                >内镜</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.infectious && row.infectious != '无' && row.infectious != 'NONE' && row.infectious != '未查' && row.infectious != 'NoCheck' ? 'red' : '#DFE2E7',
                                    borderColor: row.infectious ? '#f2b04b' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >传染病</el-tag
                            >
                            <el-tag
                                :style="{
                                    color: row.is_local_anes && row.is_local_anes == true ? '#5AA7B0' : '#DFE2E7',
                                    borderColor: row.is_local_anes ? '#5AA7B0' : '#DFE2E7',
                                    backgroundColor: 'white',
                                    fontWeight: 'bold'
                                }"
                                size="mini"
                                >局麻
                            </el-tag>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="push_status" slot-scope="{ row }">
                <i v-if="row.push_status == 1" class="el-icon-circle-check fg-primary"> </i>
                <i v-else-if="row.push_status == 2" class="el-icon-circle-check-outline fg-warning" :title="row.push_status_msg"></i>
                <i v-else-if="row.push_status == 3" class="el-icon-circle-close fg-danger" :title="row.push_status_msg"></i>
                <i v-else> </i>
            </template>
            <template slot="diseases" slot-scope="{ row }">
                <div style="min-width: 180px; white-space: normal">
                    <span>{{ row.diseases }}</span>
                </div>
            </template>
            <template slot="anaes_methods" slot-scope="{ row }">
                <el-tooltip class="item" effect="light" placement="top">
                    <div style="min-width: 200px" slot="content">{{ row.surgeries_allInfo }}</div>
                    <div style="min-width: 100px; white-space: normal">
                        <b class="ellipsis">{{ row.anaes_methods }}</b>
                        <div class="fg-info ellipsis">{{ row.relation_text }}</div>
                    </div>
                </el-tooltip>
            </template>
            <template slot="dic_section" slot-scope="{ row }"
                ><div style="min-width: 100px; white-space: normal">
                    <span>{{ row.dic_section }}</span>
                </div></template
            >
            <template slot="surgeon" slot-scope="{ row }">
                <div style="min-width: 90px; white-space: normal">
                    <span>{{ row.surgeon && `(主)${row.surgeon}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.surgeon_assistants }}</span>
                </div>
                <el-popover ref="popover1" trigger="hover" @show="showPhoto(row)"> <img style="width: 200px; height: 200px" :src="row.worker_photo" /> </el-popover>
                <img class="workerImg" v-if="isShowWorkerPhoto && row.surgeon_id && row.surgeon_photo" v-popover:popover1 :src="workerIcon" />
            </template>
            <template slot="plan_anes_doctor" slot-scope="{ row }">
                <div style="min-width: 90px; white-space: normal">
                    <span>{{ row.plan_anes_doctor && `(主)${row.plan_anes_doctor.label}` }}</span>
                </div>
                <div class="fg-info">
                    <span>{{ row.plan_viceanes_doctor && `(副)${getviceAnesDoctor(row.plan_viceanes_doctor)}` }}</span>
                </div>
            </template>
            <template slot="remark" slot-scope="{ row }">
                <div style=" white-space: normal">
                    <div class="fg-info">{{ row.his_remark }}</div>
                    <b>{{ row.remark }}</b>
                </div>
            </template>
        </crud-facecade>
        <el-dialog :title="autoScheduleTitle" :close-on-click-modal="false" :visible.sync="autoScheduleVisible" class="table-h560" width="90%">
            <ListView :datalist="autoScheduleSurgeries" :columns="autoScheduleColumnListBand" :buttons="autoScheduleButtons" @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="autoScheduleVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAutoSchedule">确 定</el-button>
            </span>
        </el-dialog>
        <cus-dialog :title="printSurenryForm.title" :visible.sync="printSurenryForm.dialogFormVisible" width="30%" @confirm="printSurenryByTime()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="daterange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <form-dialog
            :title="roomSettings.title"
            :data="roomSettings.data"
            width="40%"
            :visible.sync="roomSettings.dialogFormVisible"
            :columns="roomSettingsColumns"
            @confirm="saveSettings"
        ></form-dialog>
        <form-dialog
            :title="changeRoom.title"
            :data="changeRoom.data"
            width="40%"
            :visible.sync="changeRoom.dialogFormVisible"
            :columns="changeRoom.changeRoomColumns"
            @confirm="changeRoomSave"
        ></form-dialog>
        <form-dialog
            :title="setAnesDoctor.title"
            :data="setAnesDoctor.data"
            width="40%"
            :visible.sync="setAnesDoctor.dialogFormVisible"
            :columns="setAnesDoctor.setAnesDoctorColumns"
            @confirm="setAnesDoctorSave"
        ></form-dialog>
        <cus-dialog :title="clearWorkers.title" :visible.sync="clearWorkers.dialogFormVisible" width="40%" @confirm="setClearWorkersSave">
            <el-row>
                <el-col :span="24" style="line-height: 35px">
                    <label style="float: left;">角色：</label>
                    <item-input style="width: 80%; float: left;"
                        type="checkboxgroup"
                        v-model="clearWorkers.workerDuties"
                        :options="[
                            { value: `3`, label: `麻醉医生` },
                            { value: `4`, label: `麻醉助手` },
                            { value: `5`, label: `巡回护士` },
                            { value: `6`, label: `器械护士` }
                        ]"
                    ></item-input>
                </el-col>
            </el-row>
        </cus-dialog>
        <EditSurgeryNew :visible.sync="edit.dialogFormVisible" :footerVisible="edit.showSaveBtn" :title="edit.title" :data="edit.data" @save-success="afterSave"></EditSurgeryNew>
        <cus-dialog :title="docinfo.title" :visible.sync="dialogFormVisible1" :footerVisible="false" width="60%" class="dialog-adverse">
            <el-row>
                <el-col :span="24" class="align-right">
                    <label style="line-height: 35px">核对人：</label>
                    <item-input
                        class="block-multi-collapse-select-width"
                        :collapseTags="true"
                        style="width: 180px"
                        type="select"
                        v-model="active_item.check_user_id"
                        :options="this.worker[`护士`]"
                        placeholder="核对人"
                    ></item-input>
                    <label style="padding-left: 30px; line-height: 35px">记录时间:</label>
                    <item-input
                        style="width: 180px"
                        :collapseTags="true"
                        :noPadding="true"
                        datetimeFormate="yyyy/MM/dd HH:mm"
                        type="datetime"
                        v-model="active_item.check_date"
                        placeholder="记录时间"
                    ></item-input>
                    <span style="padding-left: 30px">
                        <el-button type="primary" size="mini" plain @click="SaveChanges('合格')" style="margin-left: unset !important">核对通过</el-button>
                        <el-button type="primary" size="mini" plain @click="SaveChanges('不合格')" style="margin-left: unset !important">核对不通过</el-button>
                    </span>
                </el-col>
            </el-row>
            <DocFrame
                ref="doc"
                :guid="`checklist_${this.active_item.dic_operating_room_id}_${this.active_item.date}_SSJJC001`"
                :docno="this.$root.DOCUMENT && this.$root.DOCUMENT.SSJJC001"
                :surgeryId="0"
                @saved="afterDocSaved"
                :docname="docinfo.title"
            ></DocFrame>
        </cus-dialog>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
        <form-dialog
            :title="exportExcel.title"
            :data="exportExcel.data"
            width="40%"
            :visible.sync="exportExcel.dialogFormVisible"
            :columns="exportExcel.Columns"
            @confirm="exportExcelSave"
        ></form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import EditSurgeryNew from './EditSurgeryNew.vue'
export default {
    name: `ScheduleSurgeryNew`,
    components: { draggable, EditSurgeryNew },
    props: {},
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }
        let offset = (this.$root.ScheduleQueryDateOffset || ``).split(`,`)
        let firstOffSetDate = 1
        if (offset && offset.length == 3) {
            firstOffSetDate = offset[0] // 排程日期
        }

        return {
            lastalertmsg: ``,
            title: `手术排程`,
            roomStyle: {
                color: ``,
                backgroundColor: ``,
                fontSize: ``,
                activecolor: ``,
                activebackgroundColor: ``,
                activefontSize: ``,
                isEnable: `0`, // 是否启用人员配置背景色
                bgColor: ``, // 人员配置对应背景色展示
                activebgColor: `` // 人员配置对应手术间选中时背景色展示
            },
            rejectReasons: [],
            printSurgeryConfigs: [],
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                emitBtnName: ``,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            surgeryIds: [],
            surgeryinfopush: this.$root.SurgeryInfoPush,
            scheduleSurgeryStyle: this.$root.ScheduleSurgeryStyle,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            isLoadToSchedule: true, // 默认选中待排程卡片
            isLoadScheduled: false, // 已排程卡片
            unschedule_list: [], // 待排程列表
            unScheduledLength: 0, // 待排程数量
            ScheduledLength: 0, // 已排程数量
            scheduled_list: [], // 已排程列表
            activeRoomScheduled_list: [], // 手术间已排程列表
            docinfo: { title: `手术间检查单`, docbizid: 0 },
            dialogFormVisible1: false,
            active_item: {
                id: 0,
                date: null,
                dic_operating_room_id: 0,
                operating_ward: ``,
                operating_room: ``,
                check_user: {},
                check_user_id: 0,
                check_date: new Date()
            },
            scheduling_date: this.$moment()
                .add(firstOffSetDate, `days`)
                .format(`YYYY/MM/DD 00:00:00`), // 排程日期
            o_dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            active_room_id: 0, // 当前手术间Id
            scheduling_way: 1, // 排程助手  1=按科室 2=按术者 3=按术式
            url2: {
                // 待排程和已排程，调用
                area: `unschedule_surgery`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return this.loadUnScheduledAndScheduled()
                }
            },
            url: {
                // 手术间视图卡片
                area: `schedule_surgery`,
                baseURL: `/api/Preoperative/Apply`,
                get: paras => {
                    return new Promise(resolve => {
                        this.loadActiveRoomScheduled().then(data => {
                            this.activeRoomScheduled_list = data
                            resolve(data)
                        })
                    })
                },
                putMany: data => {
                    let that = this
                    let reqs = data.map(d => {
                        let info = _.filter(this.activeRoomScheduled_list, { id: d.id })[0]
                        d.scheduled_sequence = d.scheduled_sequence
                        d.plan_anes_doctor = d.plan_anes_doctor && d.plan_anes_doctor.map(a => a && a.value)
                        d.plan_anes_assistants = d.plan_anes_assistants && d.plan_anes_assistants.map(a => a && a.value)
                        d.plan_circuit_nurse = d.plan_circuit_nurse && d.plan_circuit_nurse.map(a => a && a.value)
                        d.plan_equipment_nurse = d.plan_equipment_nurse && d.plan_equipment_nurse.map(a => a && a.value)
                        d.visit_info = {
                            id: info.visit_id,
                            enum_visit_type: info.enum_visit_type,
                            visit_no: info.visit_no,
                            outpatient_no: info.outpatient_no,
                            name: info.patient_name
                        }
                        return this.myaxios.put(`/api/Preoperative/Apply/UpdateNewSchedule`, d)
                    })

                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.all(...reqs)
                        req.then(res => {
                            that.$message.success(`保存成功`)
                            resolve(res)
                        }).catch(e => {
                            reject(e)
                        })
                    })
                }
            },
            buttons: [],
            checkedRows: [],
            dataArea: false,
            operation_ward_all: undefined,
            autoScheduleSurgeries: [],
            autoScheduleVisible: false,
            autoScheduleColumnListBand: [],
            workerIcon: `../../static/img/avatar/default/surgeon_photo.png`,
            isShowWorkerPhoto: (!!(this.$root.isShowWorkerPhoto && this.$root.isShowWorkerPhoto == `1`)),
            autoScheduleButtons: [
                {
                    // class:"is-circle",
                    label: `移除`,
                    icon: ``,
                    type: `danger`,
                    emit: `cancelAutoSchedule`,
                    permission: `default`
                }
            ],
            autoScheduleColumnList: [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true
                },

                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`Schedule_new.visit_no`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `主刀医生`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    isListable: true
                }
            ],
            autoScheduleUrl: { get: `/api/Preoperative/Schedule/GetAutoScheduleBySection` },
            roomSettings: {
                title: `手术间设置`,
                data: {},
                dialogFormVisible: false,
                columns: []
            },
            printSurenryForm: {
                dialogFormVisible: false,
                from_to: [],
                code: ``,
                title: `日期区间打印`
            },
            changeRoom: {
                title: `更换手术间`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                dialogFormVisible: false,
                changeRoomColumns: [{
                    type: `select`,
                    prop: `dic_recovery_ward_id`,
                    label: `手术区`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return d.disabled === false
                        })
                        if (this.IsCrossRegionScheduling) {

                        } else {
                            data = _.filter(data, { value: this.dic_operating_ward_id })
                        }
                        return data
                    }
                }, {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                            return (d.value == row.dic_recovery_ward_id)
                        })
                        return _.filter(data[0] && data[0].operation_room, (d) => {
                            return d.disabled === false
                        }) || []
                    }
                }]
            },
            setAnesDoctor: {
                title: `设置麻醉医生`,
                data: {},
                dialogFormVisible: false,
                setAnesDoctorColumns: [
                    {
                        type: `remoteselect`,
                        prop: `plan_anes_doctor`,
                        label: `麻醉医生`,
                        isCreatable: true,
                        isEditable: true,
                        options: (that, { row }) => {
                            return q => {
                                let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                                if (this.$root.UseASACheck == `1`) {
                                    works = works.map(d => {
                                        return {
                                            label: d.label,
                                            value: d.value,
                                            jianpin: d.jianpin,
                                            card_no: d.card_no,
                                            worker_duty: d.worker_duty,
                                            //  code: d.code,
                                            // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                            code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code
                                        }
                                    })
                                }
                                if (q && q.keyword) {
                                    return works.filter(d => {
                                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                    })
                                } else {
                                    return works
                                }
                            }
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }]
            },
            clearWorkers: {
                title: `清除人员安排`,
                data: {},
                dialogFormVisible: false,
                workerDuties: []
            },
            edit: {
                dialogFormVisible: false,
                surgeryId: 0,
                showSaveBtn: true
            },
            selectsurgeryType: 0,
            exportExcel: {
                title: `导出数据过滤`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                exportDatas: [],
                dialogFormVisible: false,
                Columns: [{
                    type: `checkboxgroup`,
                    prop: `status`,
                    label: `状态:`,
                    options: [{ label: `已排程`, value: `已排程` }, { label: `进行中`, value: `进行中` }, { label: `手术结束`, value: `手术结束` }, { label: `苏醒中`, value: `苏醒中` }, { label: `苏醒结束`, value: `苏醒结束` }],
                    colspan: 24,
                    default: [
                        `已排程`,
                        `进行中`,
                        `手术结束`,
                        `苏醒中`,
                        `苏醒结束`
                    ]
                }]
            },
            isEnableFilterStatusForExportExcel: this.$root.IsEnableFilterStatusForExportExcel, // 是否开启导出Excel 按状态过滤数据,
            isShowInfectiousAlert: this.$root.IsShowInfectiousAlert,
            showSurgeryAlert: this.$root.proc_ShowSurgeryAlert,
            isShowInfectiousAlertConfigs: [],
            surgeryNameConfig: this.$root.SurgeryNameConfig,
            scheduleWorkerFilter: this.$root.ScheduleWorkerFilter || `0`
        }
    },
    created() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
        this.$store.dispatch(`ADD_SECTION`)
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadRoomStyle()
        if (this.isShowInfectiousAlert && this.isShowInfectiousAlert.trim() != ``) {
            let config = JSON.parse(this.isShowInfectiousAlert)
            if (config && config.length > 0) {
                this.isShowInfectiousAlertConfigs = config.filter(d => {
                    return d.IsEnable && d.IsEnable == 1
                })
            }
        }
        this.lastalertmsg = ``
    },
    mounted() {
        this.ReloadRoom()
        this.loadRejectResons()
        this.loadPrintSurgeryConfig()
    },
    computed: {
        ...mapGetters([
            `operation_ward`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `listview/remove_item`,
            `section`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `screenHeight`,
            `permissions`,
            `active_ward`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (!this.issetoperatingward && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        IsCrossRegionScheduling() {
            return _.find(this.permissions, { no: `scheduling:CrossRegionScheduling` }) != undefined
        },
        IsMoveEmergencyPermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveEmergency` }) != undefined
        },
        IsMoveElectivePermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveElective` }) != undefined
        },
        IsMoveDeadlinePermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveDeadline` }) != undefined
        },
        IsMovePermission() {
            return _.find(this.permissions, { no: `scheduling_list_toScheduling` }) != undefined
        },
        tableStyle() {
            return this.scheduleSurgeryStyle
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 230) || 0
        },
        operationRoom: {
            get() {
                let r = this.operation_ward_all && this.operation_ward_all[this.dic_operating_ward_id]
                return _.orderBy(r, `display_order`) || []
            },
            set() {}
        },
        activeRoom() {
            let r = _.find(this.operationRoom, { id: this.active_room_id })
            return r || { name: `待排程` }
        },
        columnList() {
            let me = this
            let listeditWorker = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:list_editWorker`) === -1
            let list = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    queryable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`Schedule_new.visit_no`),
                    queryable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    queryable: false,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术`,
                    queryable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `350`,
                    isListable: true,
                    area: [2],
                    tooltip: false
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `350`,
                    isListable: true,
                    area: [1],
                    tooltip: false
                },
                // {
                //     type: `number`,
                //     prop: `display_order`,
                //     label: `排序`,
                //     isListable: false,
                //     area: [1, 2],
                //     sortable: true
                // },
                // {
                //     type: `number`,
                //     prop: `sequence_s`,
                //     label: `台次`,
                //     isListable: false,
                //     area: [1, 2],
                //     sortable: true
                // },
                {
                    type: `number`,
                    prop: `sequence`,
                    label: `申请台次`,
                    isListable: true,
                    width: `100`,
                    readonly: true,
                    area: [1, 2],
                    sortable: false
                },
                {
                    type: `number`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    isListable: true,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || this.isLoadToSchedule == true || this.isLoadScheduled == true
                    },
                    area: [1],
                    sortable: true
                },
                {
                    type: `number`,
                    prop: `scheduled_sequence`,
                    label: `台次`,
                    isListable: true,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || this.isLoadToSchedule == true || this.isLoadScheduled == true
                    },
                    area: [2],
                    sortable: false
                },
                {
                    type: `custom`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `100`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `150`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `string`,
                    prop: `surgical_site`,
                    label: `手术部位`,
                    width: `150`,
                    isListable: true,
                    queryable: false,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    sortable: true,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true,
                    sortable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    width: `200`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `anaes_methods`,
                    label: `计划麻醉方式`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2],
                    tooltip: false
                },
                {
                    type: `custom`,
                    prop: `surgeon`,
                    label: `主刀医生`,
                    width: `120`,
                    isListable: true,
                    area: [1, 2]
                },
                {
                    type: `custom`,
                    prop: `plan_anes_doctor`,
                    label: `麻醉医生`,
                    width: `120`,
                    isListable: true,
                    area: [2]
                },
                {
                    // type: `select`,
                    type: `remotemultiselect`,
                    prop: `plan_anes_doctor`,
                    showCount: 4,
                    collapseTags: false,
                    label: this.T(`Schedule.plan_anes_doctor`),
                    width: `240`,
                    isListable: true,
                    colspan: 6,
                    isShowPhoto: this.isShowWorkerPhoto,
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            }
                            if (this.$root.UseASAeCheck == `1`) {
                                return worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    area: [1]
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    showCount: 4,
                    collapseTags: false,
                    label: this.T(`Schedule.plan_anes_assistants`),
                    width: `200`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            }
                            if (this.$root.UseASAeCheck == `1`) {
                                return worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let hsworkersarr = _.cloneDeep(hsworkers)
                            if (me.scheduleWorkerFilter == `1`) {
                                hsworkersarr = _.filter(hsworkersarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            }
                            hsworkersarr.forEach((item, index) => {
                                let mc = _.find(worksarr, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    worksarr.push(item)
                                }
                            })

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: `巡回护士`,
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`Schedule.plan_equipment_nurse`),
                    width: `140`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_surgery_status > 20 || listeditWorker
                    },
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !row.dic_hospital_ward_id || _.includes(i.hospital_wardids, row.dic_hospital_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6,
                    area: [1],
                    config: {
                        collapseTags: true
                        // multipleLimit:2
                    }
                },
                {
                    type: `custom`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true,
                    width: `300`,
                    // colspan: 6,
                    area: [1, 2]
                }
                // ,
                // {
                //     type: `string`,
                //     prop: `his_remark`,
                //     label: `申请备注`,
                //     isListable: true,
                //     area: [1, 2]
                // }
            ] // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    area: [2],
                    isListable: true
                })
            }
            // 显示扩展动态列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)

            return list
        },
        columnList2() {
            return _.filter(this.columnList, d => {
                return d.area.indexOf(2) > -1
            }).concat([
                {
                    type: `buttongroup`,
                    prop: `oper2`,
                    width: `60`,
                    label: `操作`,
                    fixed: `right`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain is-circle`,
                            label: ``,
                            icon: `el-icon-edit-outline`,
                            type: `primary`,
                            emit: `loadSurgeryEditView`,
                            permission: `default`,
                            tooltip: `编辑`
                        }
                    ]
                }
            ])
        },
        columnList3() {
            return _.filter(this.columnList, d => {
                return d.area.indexOf(1) > -1
            }).concat([
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    width: `125`,
                    label: `操作`,
                    isListable: true,
                    readonly: false,
                    fixed: `right`,
                    options: (that, { row }) => {
                        if (row.enum_surgery_status == 20) {
                            return [
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-edit-outline`,
                                    type: `primary`,
                                    emit: `loadSurgeryEditView`,
                                    permission: `default`,
                                    tooltip: `编辑`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-close`,
                                    type: `danger`,
                                    emit: `cancelSchedule`,
                                    permission: `surgery_list:cancelSchedule`,
                                    tooltip: `取消排程`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-printer`,
                                    type: `primary`,
                                    emit: `printOne`,
                                    permission: `default`,
                                    tooltip: `打印`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-edit-outline`,
                                    type: `primary`,
                                    emit: `loadSurgeryEditView`,
                                    permission: `default`,
                                    tooltip: `编辑`
                                },
                                {
                                    class: `is-plain is-circle`,
                                    label: ``,
                                    icon: `el-icon-printer`,
                                    type: `primary`,
                                    emit: `printOne`,
                                    permission: `default`,
                                    tooltip: `打印`
                                }
                            ]
                        }
                    }
                }
            ])
        },
        roomSettingsColumns() {
            // 没有应用麻醉人员权限
            let editWorker = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            return [
                {
                    type: `select`,
                    prop: `anesthetist_id`,
                    label: `麻醉医生`,
                    colspan: 12,
                    readonly: editWorker,
                    options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                },
                {
                    type: `multiselect`,
                    prop: `anesthetist_assistant_id`,
                    label: `麻醉助手`,
                    colspan: 12,
                    readonly: editWorker,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        let workers = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                        let deepworkers = JSON.parse(JSON.stringify(workers))
                        let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                        hsworkers.forEach((item, index) => {
                            let mc = _.find(deepworkers, x => x.value == item.value)
                            if (mc) {
                            } else {
                                deepworkers.push(item)
                            }
                        })
                        return deepworkers
                    },
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `circuit_nurse_id`,
                    label: `巡回护士`,
                    options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    colspan: 12,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `multiselect`,
                    prop: `equipment_nurse_id`,
                    label: `器械护士`,
                    options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    colspan: 12,
                    readonly: noHaveNursePermission,
                    config: {
                        collapseTags: false
                    }
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `分配科室`,
                    options: this.section,
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `surgeon_id`,
                    label: `分配术者`,
                    options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `dic_surgery_name`,
                    label: `分配术式`,
                    colspan: 12
                }
            ]
        },
        autoScheduleTitle() {
            return `排程助手(${this.autoScheduleSurgeries.length}/${this.unScheduledLength})`
        },
        titleLabel() {
            return function(row) {
                let doctor = ``
                if (row.plan_anes_doctor != null) {
                    if (_.isArray(row.plan_anes_doctor)) {
                        if (row.plan_anes_doctor.length > 0) {
                            doctor = `(主)` + row.plan_anes_doctor[0].label
                        }
                    } else {
                        doctor = `(主)` + row.plan_anes_doctor.label
                    }
                }

                let title = `患者:${row.patient_name} 性别:${row.sex || `--`} 年龄:${row.age || `--`} 
病例号:${row.visit_no || `--`} 
术前诊断:${row.diseases || `--`}
拟施手术:${row.surgeries_allInfo || `--`}
主刀医生:${row.surgeon || `--`}
手术助手:${row.surgeon_assistants || ``}
手术指导:${this.getviceAnesDoctor(row.plan_surgery_guidance) || `--`} 
手术科室:${row.dic_section || `--`}
麻醉医生:${doctor} ${row.plan_viceanes_doctor == null ? `` : `(副)` + this.getviceAnesDoctor(row.plan_viceanes_doctor)}
麻醉助手:${row.anes_assistants || ``}
麻醉指导:${this.getviceAnesDoctor(row.plan_anes_guidance) || `--`} 
申请台次:${row.sequence || ``}
申请时间:${this.$moment(row.apply_time).format(`YYYY-MM-DD HH:mm:ss`)}
备注:${row.his_remark || ``}
传染病:${row.infectious || ``}
麻醉类型:${row.is_local_anes_val || ``}
`
                return title
            }
        },
        styleObject() {
            return function(active, setting) {
                let style = {
                    color: active ? this.roomStyle.activecolor : this.roomStyle.color,
                    fontSize: active ? this.roomStyle.activefontSize : this.roomStyle.fontSize
                }
                if (this.roomStyle.isEnable === `1`) {
                    // 读取参数配置中的颜色，没有配置数据时默认白色
                    let backgroundColor = this.roomStyle.backgroundColor == `` ? `white` : this.roomStyle.backgroundColor
                    let activebackgroundColor = this.roomStyle.activebackgroundColor == `` ? `white` : this.roomStyle.activebackgroundColor
                    let bgColor = this.roomStyle.bgColor == `` ? `white` : this.roomStyle.bgColor
                    let activebgColor = this.roomStyle.activebgColor == `` ? `white` : this.roomStyle.activebgColor
                    // 配置了麻醉医生，没有配置巡回护士或器械护士
                    if (setting.anesthetist_id && !setting.circuit_nurse_id && !setting.equipment_nurse_id) {
                        style.background = active
                            ? `linear-gradIEnt(${activebgColor} 50%,${activebackgroundColor} 50%)`
                            : `linear-gradIEnt(${bgColor} 50%,${backgroundColor} 50%)`
                    } else if (!setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了巡回护士或器械护士，没有配置麻醉医生
                        style.background = active
                            ? `linear-gradIEnt(${activebackgroundColor} 50%,${activebgColor} 50%)`
                            : `linear-gradIEnt(${backgroundColor} 50%,${bgColor} 50%)`
                    } else if (setting.anesthetist_id && (setting.circuit_nurse_id || setting.equipment_nurse_id)) {
                        // 配置了麻醉医生和巡回护士/器械护士
                        style.background = active
                            ? `linear-gradIEnt(${activebgColor} 50%,${activebgColor} 50%)`
                            : `linear-gradIEnt(${bgColor} 50%,${bgColor} 50%)`
                    } else {
                        style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                    }
                } else {
                    style.backgroundColor = active ? this.roomStyle.activebackgroundColor : this.roomStyle.backgroundColor
                }
                return style
            }
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        }
    },
    methods: {
        ishavehelpSection(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:helpSection` || item.permission === `scheduling:helpWorker` || item.permission === `scheduling:helpSurgery` || item.permission === `scheduling:helpChangeRoom` || item.permission === `scheduling:helpSetAnesDoctor` ||
                item.permission === `scheduling:clearWorkersSettings`) != -1
            }
        },
        isHaveCancelSchedule(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:cancelSchedule` || item.permission === `scheduling:rejectApprove` || item.permission === `scheduling:rejectApply`) != -1
            }
        },
        cancel(command) {
            let that = this
            if (command == `cancelSchedule`) {
                that.cancelScheduleAll()
            }
            if (command == `rejectApprove`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApply`) {
                that.loadingOverruleView(command)
            }
        },
        loadingOverruleView(btnName) {
            let that = this
            this.surgeryIds = []
            let rejectApplyMsgs = ``
            if (that.checkedRows && that.checkedRows.length > 0) {
                if (btnName == `rejectApply`) {
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                } else {
                    that.checkedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            this.surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                }
            }

            if (this.surgeryIds.length == 0) {
                this.$message.warning(`请选择需要驳回的手术!`)
                return
            }

            // 增加驳回前提示
            rejectApplyMsgs = rejectApplyMsgs.slice(0, rejectApplyMsgs.length - 1)
            if (btnName == `rejectApply`) {
                rejectApplyMsgs += `的手术申请`
            } else {
                rejectApplyMsgs += `的手术审核`
            }
            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将驳回${rejectApplyMsgs}`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    this.overrule.emitBtnName = btnName
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadRejectResons() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ApplyRejectResons`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.rejectReasons = data.value.trim().split(`,`).map(x => {
                            return {
                                label: x,
                                value: x
                            }
                        })
                    } else {
                        this.rejectReasons = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPrintSurgeryConfig() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=PrintSurgeryConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.printSurgeryConfigs = JSON.parse(data.value)
                    } else {
                        this.printSurgeryConfigs = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        cancelScheduleAll() {
            let that = this
            let pmise = new Promise((resolve, reject) => {
                let chckrows = _.filter(this.checkedRows, { enum_surgery_status: 20 })
                console.log(chckrows)
                if (chckrows.length == 0) {
                    this.$message.warning(`请选择已排程手术!`)
                    return
                }
                if (chckrows.length > 0) {
                    let msgs = ``
                    chckrows.map(d => {
                        msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                    })
                    msgs = msgs.slice(0, msgs.length - 1)
                    return this.$confirm(`请确认是否取消${msgs}的排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(chckrows)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    that.$message.success(`请选择已排程手术!`)
                }
            })

            pmise
                .then(crs => {
                    let reqs =
                        crs &&
                        crs.map(d => {
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d.id}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                            this.$message.success(`取消排程成功`)
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        saveOverrule(row) {
            let that = this
            console.log(that.surgeryIds)
            if (that.surgeryIds.length == 0) {
                this.$message.warning(`请选择需要驳回的手术!`)
                return
            }

            try {
                that.surgeryIds.map(d => {
                    let requestData = {
                        id: d,
                        visit_info: null,
                        reject_reason: row.reject_reason
                    }
                    if (that.overrule.emitBtnName == `rejectApply`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
                        req.then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                            // 调用手术回写
                            let pushModel = {
                                surgeryId: d,
                                surgeryInfoSendType: 1
                            }
                            var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                            reps.then(data => {
                            })
                        })
                    }
                    if (that.overrule.emitBtnName == `rejectApprove`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/RejectApprove`, requestData)
                        req.then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                        })
                    }
                })
                that.$message.success(`手术驳回成功`)
                that.surgeryIds = []
                console.log(that.surgeryIds)
                that.overrule.dialogFormVisible = false
            } catch (e) {
                that.$message.error(`手术驳回失败`)
            }
        },
        showPhoto(row) {
            if (row.surgeon_id && row.surgeon_photo) {
                row.worker_photo = `${this.$root.BASE_URL}api/AcisSystem/Worker/GetPictureFile/${row.surgeon_id}?fileName=${row.surgeon_photo}`
            } else {
                row.worker_photo = this.workerIcon
            }
        },
        getviceAnesDoctor(doctors) {
            return _.join(
                _.map(doctors, d => d.label),
                `,`
            )
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
            let that = this
            let surgeryIds = []
            if (surgeryStatus == 10) {
                surgeryIds.push(surgeryId)
                let req = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeries?date=${that.scheduling_date}&roomId=${operatingRoomId}`, surgeryIds)
                req.then(data => {
                    that.refreshList()
                }).catch(e => {
                    that.$message.error(`排程失败`)
                })
            } else {
                that.refreshList()
            }
        },
        refreshList() {
            this.ReloadRoom()
            this.ReloadListData()
        },
        pushSchedule() {
            let pushRows = []
            if (this.checkedRows.length > 0) {
                pushRows = this.checkedRows
            } else {
                // 若未勾选则回传全部
                pushRows = this.unschedule_list.concat(this.scheduled_list)
            }
            if (pushRows.length > 0) {
                let reqs = pushRows.map(d => {
                    // if (d.push_status != 1) {
                    let postdata = {
                        surgeryId: d.id,
                        surgeryInfoSendType: 2
                    }
                    return this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, postdata)
                    // }
                })
                this.myaxios.all(...reqs).then(() => {
                    // this.ReloadRoom()
                    this.ReloadListData()
                    this.$message.success(`排程回传完成`)
                })
            } else {
                this.$message.warning(`请先选择要回传的记录！`)
            }
        },
        cancelSchedule({ index, row }) {
            let pmise = new Promise((resolve, reject) => {
                let chckrows = _.filter(this.checkedRows, { enum_surgery_status: 20 })
                if (chckrows.length > 0) {
                    return this.$confirm(`检测到选择了多条数据，是否全部取消排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(chckrows)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    return this.$confirm(`是否取消排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve([row])
                        })
                        .catch(e => {
                            reject([])
                        })
                }
            })

            pmise
                .then(crs => {
                    let reqs =
                        crs &&
                        crs.map(d => {
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d.id}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            this.ReloadRoom()
                            this.ReloadListData()
                            this.$message.success(`取消排程成功`)
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        ScheduleSurgeries(evt, room) {
            let that = this
            let req = that.myaxios.put(
                `/api/Preoperative/Schedule/ScheduleSurgeries?date=${that.scheduling_date}&roomId=${room.id}`,
                that[`listview/remove_item`] && that[`listview/remove_item`].map(d => d.id)
            )
            req.then(data => {
                that.ReloadRoom()
                that.ReloadListData()
                that.$message.success(`保存成功`)
            }).catch(e => {
                that.$message.error(`保存失败`)
            })
        },
        loadUnScheduledAndScheduled() {
            let that = this
            return new Promise(resolve => {
                // 获取待排程
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetUnScheduled`, { date: that.dataArea ? `` : that.scheduling_date })
                // 获取已排程
                let req1 = this.myaxios.get(`/api/Preoperative/Schedule/GetNewScheduled`, { date: that.dataArea ? `` : that.scheduling_date })
                // 获取手术提醒
                let req2 = this.myaxios.get(`/api/Preoperative/Schedule/GetSurgeryAlertInfo`, { date: that.dataArea ? `` : that.scheduling_date })
                this.myaxios.all(req, req1, req2).then(([data, data1, alertInfo]) => {
                    // added by xiaorui,ACIS-23994 ,手术排程 数据列表 安排术间增加了3个权限控制
                    if (!this.IsMoveEmergencyPermission) {
                        data = _.filter(data, function(i) {
                            return (i.enum_surgery_type !== 1 && i.enum_surgery_type !== null)
                        })
                    }
                    if (!this.IsMoveElectivePermission) {
                        data = _.filter(data, function(i) {
                            return i.enum_surgery_type !== 2
                        })
                    }
                    if (!this.IsMoveDeadlinePermission) {
                        data = _.filter(data, function(i) {
                            return i.enum_surgery_type !== 3
                        })
                    }
                    let r = _.filter(data, { dic_operating_ward_id: this.dic_operating_ward_id }).map(d => {
                        if (d.sequence && this.IsNum(d.sequence)) {
                            d.sequence_s = d.sequence && parseInt(d.sequence)
                        } else {
                            d.sequence_s = d.sequence
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsMovePermission) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)

                        return d
                    })

                    if (this.IsCrossRegionScheduling) {
                        r = _.filter(data, {}).map(d => {
                            if (d.sequence && this.IsNum(d.sequence)) {
                                d.sequence_s = d.sequence && parseInt(d.sequence)
                            } else {
                                d.sequence_s = d.sequence
                            }
                            if (this.IsMovePermission) {
                                d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                            } else {
                                d.class_name = `ignore-drag`
                            }
                            d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                            d.worker_photo = `` // 手术医生照片
                            return d
                        })
                    }
                    that.unScheduledLength = r.length
                    // let toSchedules = _.orderBy(r, [`display_order`, `dic_section_id`])
                    let toSchedules = r
                    let r1 = _.filter(data1, { dic_operating_ward_id: this.dic_operating_ward_id }).map(d => {
                        if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                            d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                        } else {
                            d.sequence_s = d.scheduled_sequence
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsMovePermission) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片
                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)

                        return d
                    })
                    if (this.IsCrossRegionScheduling) {
                        r1 = _.filter(data1, {}).map(d => {
                            if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                                d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                            } else {
                                d.sequence_s = d.scheduled_sequence
                            }
                            if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                                var surgeriesT = ``
                                d.surgery_region.forEach(sritem => {
                                    surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                                })
                                d.surgeries = surgeriesT.slice(0, -1)
                            }
                            if (this.IsMovePermission) {
                                d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                            } else {
                                d.class_name = `ignore-drag`
                            }
                            d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                            d.worker_photo = `` // 手术医生照片
                            return d
                        })
                    }
                    that.ScheduledLength = r1.length
                    // let schedules = _.orderBy(r1, [`display_order`, `dic_operating_room_id`])
                    let schedules = r1
                    that.unschedule_list = that.isLoadToSchedule ? toSchedules : []
                    that.scheduled_list = that.isLoadScheduled ? schedules : []
                    let allschedules = that.scheduled_list.concat(that.unschedule_list)
                    // 根据选择的手术类型做过滤，择期，急诊，日间
                    if (allschedules.length > 0 && that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.enum_surgery_type == that.selectsurgeryType
                            })
                        }

                        if (that.selectsurgeryType == 3) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }
                    resolve(allschedules)
                    // added by xiaorui，是否显示传染病提示

                    // if (this.$root.IsShowInfectiousAlert && this.$root.IsShowInfectiousAlert == `1`) {
                    //     let alertmsg = ``
                    //     _.filter(
                    //         allschedules,
                    //         i => i.infectious && i.infectious != `无` && i.infectious != `NONE` && i.infectious != `NoCheck` && i.infectious != `未查` && i.infectious != `未检查`
                    //     ).map(d => {
                    //         alertmsg += `<strong>${d.patient_name}是${d.infectious}患者</strong><br/>`
                    //     })
                    //     if (alertmsg) {
                    //         this.$alert(alertmsg, `提示`, {
                    //             dangerouslyUseHTMLString: true,
                    //             type: `warning`
                    //         })
                    //         return true
                    //     }
                    // }
                    let alertmsg = ``
                    // 存储过程
                    if (that.showSurgeryAlert && that.showSurgeryAlert.trim() != `` && alertInfo.length > 0) {
                        let ids = _.map(allschedules, d => d.id)
                        alertInfo = _.filter(alertInfo, function(i) {
                            return _.includes(ids, i.biz_surgeryinfo_id)
                        })
                        console.log(alertInfo)
                        alertInfo.forEach(t => {
                            alertmsg += `<strong>${t.msg}</strong><br/>`
                        })
                    } else if (that.isShowInfectiousAlertConfigs && that.isShowInfectiousAlertConfigs.length > 0) {
                        that.isShowInfectiousAlertConfigs.forEach(t => {
                            _.filter(
                                allschedules,
                                i => i[t.Field] && i[t.Field] != `无` && i[t.Field] != `NONE` && i[t.Field] != `NoCheck` && i[t.Field] != `未查` && i[t.Field] != `未检查`
                            ).map(d => {
                                alertmsg += `<strong>${d.patient_name}是${d[t.Field]}${t.Remark}患者</strong><br/>`
                            })
                        })
                        if (alertmsg && that.lastalertmsg != alertmsg) {
                            that.lastalertmsg = alertmsg
                            this.$alert(alertmsg, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return true
                        }
                    }

                    if (alertmsg && alertmsg != `` && that.lastalertmsg != alertmsg) {
                        that.lastalertmsg = alertmsg
                        this.$alert(alertmsg, `提示`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                        return true
                    }

                    // added by xiaorui，是否显示二次手术提示
                    if (this.$root.IsShowMutiSurgery && this.$root.IsShowMutiSurgery == `1`) {
                        let alertmsg1 = ``
                        _.filter(allschedules, i => i.muti_surgery_count > 0).map(d => {
                            alertmsg1 += `<strong>${d.patient_name}已在${this.$moment(d.surgery_time).format(`YYYY-MM-DD HH:mm`)}手术,本次为第${d.muti_surgery_count + 1}次提交手术;</strong><br/>`
                        })

                        if (alertmsg1) {
                            this.$alert(alertmsg1, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return true
                        }
                    }
                })
            })
        },
        loadActiveRoomScheduled() {
            // 获取各手术间排程数据
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetScheduled`, { date: that.scheduling_date, roomId: that.active_room_id })
                req.then(data => {
                    let allschedules = data
                    // 根据选择的手术类型做过滤，择期，急诊，日间
                    if (that.selectsurgeryType > 0) {
                        if (that.selectsurgeryType == 1 || that.selectsurgeryType == 2) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.enum_surgery_type == that.selectsurgeryType
                            })
                        }

                        if (that.selectsurgeryType == 3) {
                            allschedules = _.filter(allschedules, function(i) {
                                return i.is_day_surgery == true
                            })
                        }
                    }

                    let r = _.filter(allschedules, { dic_operating_ward_id: this.dic_operating_ward_id }).map(d => {
                        if (d.scheduled_sequence && this.IsNum(d.scheduled_sequence)) {
                            d.sequence_s = d.scheduled_sequence && parseInt(d.scheduled_sequence)
                        } else {
                            d.sequence_s = d.scheduled_sequence
                        }
                        if (that.surgeryNameConfig && _.includes(that.surgeryNameConfig, `Surgery_Region`) && d.surgery_region) {
                            var surgeriesT = ``
                            d.surgery_region.forEach(sritem => {
                                surgeriesT += sritem.surgery_name + (sritem.surgery_region && that.surgeryNameConfig.replace(`Surgery_Region`, sritem.surgery_region)) + `,`
                            })
                            d.surgeries = surgeriesT.slice(0, -1)
                        }
                        if (this.IsMovePermission) {
                            d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        } else {
                            d.class_name = `ignore-drag`
                        }
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.worker_photo = `` // 手术医生照片

                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)

                        // added by xiaorui 麻醉医生改成多选了，这里把（主）麻醉医生和（副）麻醉医生合并显示在一起
                        let doctors = []
                        if (d.plan_anes_doctor != null) {
                            doctors = doctors.concat(d.plan_anes_doctor)
                        }
                        if (d.plan_viceanes_doctor != null) {
                            doctors = doctors.concat(d.plan_viceanes_doctor)
                        }
                        d.plan_anes_doctor = doctors.length > 0 ? doctors : null
                        return d
                    })
                    // let r1 = _.orderBy(r, [`display_order`, `dic_operating_room_id`])
                    that.activeRoomScheduled_list = r
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        ReloadRoom() {
            // GET /api/Preoperative/Schedule/GetRooms
            let that = this
            let req = this.myaxios.get(`/api/Preoperative/Schedule/GetRooms`, { date: that.scheduling_date })
            req.then(data => {
                that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)
            }).catch(e => {
                console.log(e)
            })
        },
        roomDragOption(isopen) {
            return {
                animation: 0,
                group: { name: `room`, put: [`listview`, `fixed-listview`], pull: false },
                disabled: !isopen,
                ghostClass: `ghost`,
                sort: false
            }
        },
        loadScheduleHelper(command) {
            let that = this
            let req
            if (command == `section`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySection`, { date: that.scheduling_date })
                that.scheduling_way = 1
            }
            if (command == `worker`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgeon`, { date: that.scheduling_date })
                that.scheduling_way = 2
            }
            if (command == `surgery`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgery`, { date: that.scheduling_date })
                that.scheduling_way = 3
            }
            if (command == `changeRoom`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择已排程手术`)
                    return
                }
                that.loadChangeRoomForm()
                return
            }
            if (command == `setAnesDoctor`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请手术`)
                    return
                }
                that.loadsetAnesDoctorForm(surgeryIds)
                return
            }
            if (command == `clearWorkers`) {
                let surgeryIds = []
                that.checkedRows.map(d => {
                    if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请或已排程手术`)
                    return
                }
                that.loadclearWorkersForm(surgeryIds)
                return
            }

            // let req = that.myaxios.get(command == 'section'?'/api/Preoperative/Schedule/GetAutoScheduleBySection':'/api/Preoperative/Schedule/GetAutoScheduleBySurgeon',{date:that.scheduling_date})
            req.then(data => {
                that.autoScheduleSurgeries = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })

                // 深拷贝一个autoScheduleColumnList
                that.autoScheduleColumnListBand = _.cloneDeep(that.autoScheduleColumnList)
                if (that.scheduling_way == 2) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeon`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                } else if (that.scheduling_way == 3) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeries`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                }

                // that.autoScheduleSurgeries = data
            }).catch(e => {
                that.autoScheduleSurgeries = []
            })
            that.autoScheduleVisible = true
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        cancelAutoSchedule({ row, index }) {
            this.autoScheduleSurgeries.splice(index, 1)
        },
        confirmAutoSchedule() {
            let that = this
            if (that.autoScheduleSurgeries.length == 0) {
                this.autoScheduleVisible = false
                return
            }
            let reqs = []
            let cms = _.groupBy(that.autoScheduleSurgeries, `dic_operating_room_id`)
            _.forEach(cms, function(value, roomId) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ScheduleSurgeries?date=${that.scheduling_date}&roomId=${roomId}`,
                    value.map(v => v.id)
                )
                reqs.push(req)
            })

            that.myaxios
                .all(...reqs)
                .then(datas => {
                    that.$message.success(`保存成功`)
                    this.ReloadRoom()
                    that.ReloadListData()
                    this.autoScheduleVisible = false
                })
                .catch(e => {
                    console.log(e)
                    that.$message.error(`保存失败`)
                })
        },
        loadSettingForm(room) {
            this.roomSettings.title = `手术间设置(${room.name})`
            this.roomSettings.dialogFormVisible = true
            let roomsetting = room.room_setting || {}
            roomsetting.dic_operating_room_id = room.id
            roomsetting.id = roomsetting.id || 0
            if (roomsetting.anesthetist_assistant_id != null) {
                roomsetting.anesthetist_assistant_id = roomsetting.anesthetist_assistant_id && roomsetting.anesthetist_assistant_id.toString().split(`,`).map(d => parseInt(d))
            }
            if (roomsetting.circuit_nurse_id != null) {
                roomsetting.circuit_nurse_id = roomsetting.circuit_nurse_id && roomsetting.circuit_nurse_id.toString().split(`,`).map(d => parseInt(d))
            }
            if (roomsetting.equipment_nurse_id != null) {
                roomsetting.equipment_nurse_id = roomsetting.equipment_nurse_id && roomsetting.equipment_nurse_id.toString().split(`,`).map(d => parseInt(d))
            }
            this.roomSettings.data = roomsetting
        },
        saveSettings(row) {
            let that = this
            // 没有应用麻醉人员权限
            let noHaveAnesthetistPermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editWorker`) === -1
            // 没有应用护士人员权限
            let noHaveNursePermission = this.permissions && this.permissions.findIndex(item => item.permission === `operation_room:editNurseWorker`) === -1
            let req = that.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: row.id,
                date: that.scheduling_date,
                dic_operating_room_id: row.dic_operating_room_id,
                dic_operating_room: {
                    id: row.dic_operating_room_id
                },
                anesthetist_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_id,
                anesthetist_assistant_id: noHaveAnesthetistPermission == true ? null : row.anesthetist_assistant_id && row.anesthetist_assistant_id.toString(),
                circuit_nurse_id: noHaveNursePermission == true ? null : row.circuit_nurse_id && row.circuit_nurse_id.toString(),
                equipment_nurse_id: noHaveNursePermission == true ? null : row.equipment_nurse_id && row.equipment_nurse_id.toString(),
                dic_section_id: row.dic_section_id || `-1`,
                surgeon_id: row.surgeon_id || `-1`,
                dic_surgery_name: row.dic_surgery_name
            })
            req.then(data => {
                that.$message.success(`保存成功`)
                this.ReloadRoom()
                that.roomSettings.dialogFormVisible = false
            }).catch(e => {})
        },
        loadChangeRoomForm() {
            if (this.checkedRows.length > 0) {
                this.changeRoom.title = `更换手术间`
                this.changeRoom.dialogFormVisible = true
                this.changeRoom.data = { 'dic_recovery_ward_id': this.dic_operating_ward_id }
            } else {
                this.$message.warning(`请选择手术！`)
            }
        },
        changeRoomSave(row) {
            let that = this
            let surgeryIds = []
            that.checkedRows.map(d => {
                if (d.enum_surgery_status == 20) {
                    surgeryIds.push(d.id)
                }
            })
            console.log(surgeryIds)
            // added by xiaorui,2022-04-05 ,ACIS-23414,手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
            if (surgeryIds.length > 0) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ChangeRoom?operatingRoomId=${row.dic_operating_room_id}&operatingWardId=${row.dic_recovery_ward_id}&date=${this.scheduling_date}`,
                    surgeryIds
                )
                req.then(data => {
                    that.ReloadRoom()
                    that.ReloadListData()
                    that.$message.success(`更换手术间成功`)
                    that.changeRoom.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`更换手术间失败`)
                })
            }
        },
        loadclearWorkersForm(surgeryIds) {
            if (surgeryIds.length > 0) {
                this.clearWorkers.title = `清除手术安排人员`
                this.clearWorkers.dialogFormVisible = true
                this.clearWorkers.workerDuties = null
                this.clearWorkers.data = { surgeryIds: surgeryIds }
            } else {
                this.$message.warning(`请选择新申请或已排程手术！`)
            }
        },
        setClearWorkersSave() {
            let that = this
            let surgeryIds = that.clearWorkers.data.surgeryIds
            let duties = that.clearWorkers.workerDuties
            if (duties && duties.length > 0) {
                let inputData = {
                    surgeryIds: surgeryIds,
                    workerDuties: duties
                }
                let req = that.myaxios.put(`/api/Preoperative/Schedule/SetClearWorkersSurgeries`, inputData)
                req.then(data => {
                    that.ReloadListData()
                    that.$message.success(`清除成功`)
                    that.clearWorkers.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`清除失败`)
                })
            }
        },
        loadsetAnesDoctorForm(surgeryIds) {
            if (surgeryIds.length > 0) {
                this.setAnesDoctor.title = `设置麻醉医生`
                this.setAnesDoctor.dialogFormVisible = true
                this.setAnesDoctor.data = { 'plan_anes_doctor': this.plan_anes_doctor, 'surgeryIds': surgeryIds }
            } else {
                this.$message.warning(`请选择新申请手术！`)
            }
        },
        setAnesDoctorSave(row) {
            let that = this
            // ACIS-23812增加批量设置麻醉医生
            if (row.surgeryIds.length > 0) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/SetAnesDoctorSurgeries?plan_anes_doctor=${row.plan_anes_doctor.value}`,
                    row.surgeryIds
                )
                req.then(data => {
                    that.ReloadRoom()
                    that.ReloadListData()
                    that.$message.success(`设置麻醉医生成功`)
                    that.setAnesDoctor.dialogFormVisible = false
                }).catch(e => {
                    that.$message.error(`设置麻醉医生失败`)
                })
            }
        },
        loadSurgeryEditView({ row }) {
            let req = this.myaxios.get(`/api/Preoperative/Apply/NewGet/${row.id}`)
            req.then(data => {
                let r = {
                    id: data.id,
                    is_archived: data.is_archived,
                    sequence: data.sequence,
                    plan_time: data.plan_time,
                    apply_time: data.apply_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.split(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    his_remark: data.his_remark,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    dic_section_id: data.dic_section_id,
                    dic_inpatient_section_id: data.dic_inpatient_section_id,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    age: data.visit_info.age,
                    height: data.visit_info.height,
                    weight: data.visit_info.weight,
                    bed_no: data.visit_info.bed_no,
                    visit_no: data.visit_info.visit_no,
                    outpatient_no: data.visit_info.outpatient_no,
                    visit_time: data.visit_info.visit_time,
                    visit_type: data.visit_info.enum_visit_type,
                    phone: data.visit_info.phone,
                    address: data.visit_info.address,
                    enum_visit_type: data.visit_info.enum_visit_type,
                    enum_pay_type: data.visit_info.enum_pay_type,
                    name: data.visit_info.name,
                    birthday: data.visit_info.birthday,
                    card_type: data.visit_info.card_type,
                    card_no: data.visit_info.card_no,
                    insurance_no: data.visit_info.insurance_no,
                    enum_blood_type: data.visit_info.enum_blood_type,
                    enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                    enum_sex: data.visit_info.enum_sex,
                    plan_diseases: data.plan_diseases,
                    plan_surgeries: data.plan_surgeries,
                    surgery_items: data.surgery_items,
                    plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                    plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                    plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.map(d => d.value),
                    plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                    plan_surgery_guidance: data.plan_surgery_guidance && data.plan_surgery_guidance.map(d => d.value),
                    plan_anes_guidance: data.plan_anes_guidance && data.plan_anes_guidance.map(d => d.value),
                    plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                    plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value)
                }
                // getone的时候把动态列字段放到obj对象里面
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, r, data)
                this.edit.title = `编辑手术`
                this.edit.data = r
                this.edit.dialogFormVisible = true

                // 手术麻醉单归档后不能在保存
                let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
                if (caneditarchived) {
                    this.edit.showSaveBtn = true
                } else {
                    this.edit.showSaveBtn = !r.is_archived
                }
            }).catch(e => console.log(e))
        },
        printOne({ row }) {
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: row.id,
                    objId: row.id
                }
            })
        },
        checkedRow({ row }) {
            this.checkedRows = row
        },
        ReloadListData() {
            this.$refs[`surgery-list`].ReloadListData()

            // this.LoadScheduledByWard()
        },
        printSurenry(command) {
            if (command == `ExportExcel`) {
                let from = this.$moment(this.scheduling_date).format(`YYYY-MM-DD`)
                let to = this.$moment(this.scheduling_date)
                    .add(1, `days`)
                    .format(`YYYY-MM-DD`)
                this.myaxios.get(`/api/Preoperative/Schedule/GetScheduleForExport`, { wardId: this.dic_operating_ward_id, from: from, to: to }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    // 是否需要按状态过滤
                    let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                    if (filterdata) {
                        this.exportExcel.exportDatas = data
                        this.exportExcel.dialogFormVisible = true
                    } else {
                        this.myaxios.export_excel(data, `手术排程.xls`)
                    }
                })
            } else {
                if (command && command.code && command.type) {
                    if (command.type == 2) { // 日期阶段打印
                        this.printSurenryForm.code = command.code
                        this.printSurenryForm.dialogFormVisible = true
                    } else {
                        let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                        req2.then(isShow => {
                            if (command.type == 1) {
                            // 选择打印
                                let printlist = []
                                if (this.checkedRows.length < 1) {
                                    printlist = this.scheduled_list
                                } else {
                                    printlist = this.checkedRows
                                }
                                if (printlist.length) {
                                    this.$store.dispatch(`PRINT_PDF`, {
                                        host: this.$root.DOCSERVICE_BASE,
                                        params: Object.assign(
                                            {
                                                docid: this.$root.DOCUMENT[command.code],
                                                id1: `99999`,
                                                objId: printlist.map(d => d.id).toString()
                                            },
                                            { isShowSendPrintMessage: isShow.value }
                                        )
                                    })
                                } else {
                                    this.$message.warning(`请选择需要打印的手术通知`)
                                }
                            } else {
                                this.$store.dispatch(`PRINT_PDF`, {
                                    host: this.$root.DOCSERVICE_BASE,
                                    params: Object.assign(
                                        {
                                            docid: this.$root.DOCUMENT[command.code],
                                            id1: ``,
                                            objId: `${this.dic_operating_ward_id}|${this.scheduling_date}`,
                                            from: this.$moment(this.scheduling_date).format(`YYYYMMDDHHmm`),
                                            to: this.$moment(this.scheduling_date)
                                                .add(1, `days`)
                                                .format(`YYYYMMDDHHmm`)
                                        },
                                        { isShowSendPrintMessage: isShow.value }
                                    )
                                })
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }
            }
        },
        exportExcelSave(row) {
            let data = this.exportExcel.exportDatas
            if (row.status.length > 0 && data.length > 0) {
                let filterExportData = !_.has(data[0], `状态`) ? data : _.filter(data, c => {
                    return _.includes(row.status, c[`状态`])
                })
                if (filterExportData.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(filterExportData, `手术排程.xls`).then(data => {
                    this.exportExcel.dialogFormVisible = false
                    this.exportExcel.exportDatas = []
                })
            }
        },
        printSurenryByTime() {
            this.printSurenryForm.dialogFormVisible = false
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[this.printSurenryForm.code],
                            id1: ``,
                            objId: `${this.dic_operating_ward_id}|${this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)}`,
                            from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        exchangeRoom($event) {
            let that = this
            let {
                moved: { newIndex, oldIndex }
            } = $event
            let oldEle = that.operationRoom[oldIndex]
            let newEle = that.operationRoom[newIndex]
            that.$confirm(`确认将 ${oldEle.name} 与 ${newEle.name} 当日排程进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${oldEle.id}&roomB=${newEle.id}&date=${this.scheduling_date}`)
                    req.then(data => {
                        // let old_v =  oldEle.visit
                        // oldEle.visit = newEle.visit
                        // newEle.visit = old_v
                        this.ReloadRoom()
                        this.ReloadListData()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        // that.$message.error('交换失败')
                    })
                })
                .catch(e => {})
        },
        dragSort({ newrow, oldrow }) {
            let req = this.myaxios.put(`/api/Preoperative/Schedule/JumpSequence/${oldrow.id}?oldsequence=${oldrow.sequence_s}&sequence=${newrow.sequence_s}`)
            req.then(() => {
                this.ReloadListData()
            })
        },
        clearButtonFocus() {
            this.$nextTick(() => {
                let active = document.activeElement
                if (active && typeof active.blur === `function`) {
                    active.blur()
                }
            })
        },
        LoadUnScheduled() {
            this.isLoadToSchedule = !this.isLoadToSchedule
            this.active_room_id = 0
            this.clearButtonFocus()
        },
        LoadAllScheduled() {
            this.isLoadScheduled = !this.isLoadScheduled
            this.active_room_id = 0
            this.clearButtonFocus()
        },
        LoadActiveRoomData(room) {
            if (this.active_room_id == room.id) {
                this.active_room_id = 0
            } else {
                this.isLoadToSchedule = false
                this.isLoadScheduled = false
                this.active_room_id = room.id
            }
        },
        loadCheckList(room) {
            this.active_item.room_setting = room.room_setting
            this.active_item.date = this.$moment(room.room_setting.date).format(`YYYY-MM-DD`)
            this.active_item.check_date = room.room_setting.check_date
            this.active_item.dic_operating_room_id = room.id
            this.active_item.check_user_id = room.room_setting.check_user_id
            this.dialogFormVisible1 = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            let req = this.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: this.active_item.room_setting.id,
                date: this.active_item.room_setting.date,
                dic_operating_room_id: this.active_item.dic_operating_room_id,
                check_user_id: this.active_item.check_user_id,
                check_date: this.active_item.check_date,
                check_result: this.btn_chk_result
            })

            req.then(data => {
                this.refreshList()
                this.dialogFormVisible1 = false
            }).catch(e => {
                console.log(e)
            })
        },
        SaveChanges(result) {
            let valid = true
            this.btn_chk_result = result
            if (valid) {
                this.$refs.doc.save()
            }
        },
        loadRoomStyle() {
            return new Promise(resolve => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ScheduleRoomStyleSetting`)
                // 手术间人员设置背景色
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=settingRoomBgColor`)
                this.myaxios.all(req2, req).then(([data, data2]) => {
                    let config = JSON.parse(data.value)
                    if (config.字体颜色) {
                        this.roomStyle.color = config.字体颜色
                    } else {
                        this.roomStyle.color = ``
                    }
                    let fontsize = parseInt(config.字体大小)
                    if (fontsize && fontsize > 0) {
                        this.roomStyle.fontSize = fontsize + `px`
                    } else {
                        this.roomStyle.fontSize = ``
                    }
                    if (config.背景色) {
                        this.roomStyle.backgroundColor = config.背景色
                    } else {
                        this.roomStyle.backgroundColor = ``
                    }

                    if (config.选中后字体颜色) {
                        this.roomStyle.activecolor = config.选中后字体颜色
                    }
                    let activefontsize = parseInt(config.选中后字体大小)
                    if (activefontsize && activefontsize > 0) {
                        this.roomStyle.activefontSize = activefontsize + `px`
                    }
                    if (config.选中后背景色) {
                        this.roomStyle.activebackgroundColor = config.选中后背景色
                    }

                    let config2 = JSON.parse(data2.value)
                    if (config2.是否启用) {
                        this.roomStyle.isEnable = config2.是否启用
                    }
                    if (config2.是否启用 && config2.是否启用 === `1`) {
                        if (config2.背景色) {
                            this.roomStyle.bgColor = config2.背景色
                        }
                        if (config2.选中后背景色) {
                            this.roomStyle.activebgColor = config2.选中后背景色
                        }
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        changed(changed) {
            this.selectsurgeryType = changed
            this.ReloadListData()
        },
        // true:数值型的，false：非数值型
        IsNum(value) {
            return typeof value === `number` && !isNaN(value)
        }
    },
    watch: {
        scheduling_date: function() {
            // 更改日期触发更新列表
            this.refreshList()
        },
        active_room_id: function() {
            // 更改当前手术室触发更新列表
            this.ReloadListData()
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            sessionStorage.setItem(`memory_operating_ward_id`, newVlaue)
            // 更改日期触发更新列表
            this.ReloadListData()
        },
        dataArea: function() {
            // 更改日期触发更新列表
            this.ReloadListData()
        },
        isLoadToSchedule: function() {
            // 触发更新列表
            this.refreshList()
        },
        isLoadScheduled: function() {
            // 触发更新列表
            this.refreshList()
        }
    }
}
</script>
<style lang="less">
/* 拖拽时的样式控制 */
.room tr {
    display: none;
}
.room .drag_target {
    color: black !important;
    outline: dotted 0.5px gray;
}
.surgery-status-tag {
    width: 12px;
    float: left;
    height: 80px;
}
.el-tag-dp {
    color: #52b8d2;
    border-color: #52b8d2;
    background-color: white;
}
.workerImg {
    float: left;
    padding: 2px 15px;
    width: 16px;
    height: 16px;
}
.workerImg:hover {
    cursor: pointer;
    transform: scale(1.2);
}
.title1 p {
    background: lightgray;
    font-size: 20px;
}
.title2 p {
    background: lightgray;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/ScheduleSurgeryNew.vue